var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevroninline = function SvgChevroninline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.244 6.029a1.073 1.073 0 0 1 1.516 0l6.426 6.426a1.073 1.073 0 0 1-1.516 1.516L10 8.301l-5.67 5.667a1.073 1.073 0 0 1-1.516-1.516L9.24 6.025l.004.004Z",
    fill: "#4A4A4A"
  })));
};
export default SvgChevroninline;